import { useState, useEffect } from 'react';

const getInitialDarkMode = () => {
    try {
        const saved = localStorage.getItem('darkMode');
        if (saved !== null) {
            return JSON.parse(saved) === true;
        }
    } catch {
        // ignore corrupted localStorage value
    }
    if (document.documentElement.classList.contains('dark')) {
        return true;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

export const useDarkMode = () => {
    const [darkMode, setDarkMode] = useState(getInitialDarkMode);

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        localStorage.setItem('darkMode', JSON.stringify(darkMode));
    }, [darkMode]);

    const toggleDarkMode = () => setDarkMode(!darkMode);

    return { darkMode, toggleDarkMode };
};